import { render, staticRenderFns } from "./ViewSoccerPredictions.vue?vue&type=template&id=1a2e9466&scoped=true&"
import script from "./ViewSoccerPredictions.vue?vue&type=script&lang=js&"
export * from "./ViewSoccerPredictions.vue?vue&type=script&lang=js&"
import style0 from "./ViewSoccerPredictions.vue?vue&type=style&index=0&id=1a2e9466&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e9466",
  null
  
)

export default component.exports